import React from 'react';
import { Colors, Icon, ProgressBar } from '@fourthwall/components';
import { CloseIcon } from '@fourthwall/icons';
import * as S from './styled';
export const LaunchStrategyContinueBarView = ({ title, progressValue, maxProgressValue, visible, onClick, onClose, }) => {
    return (React.createElement(S.Container, { onClick: onClick, visible: visible },
        React.createElement(ProgressBar, { value: progressValue, max: maxProgressValue, height: 4, barColor: Colors.G300 }),
        React.createElement(S.Content, null,
            React.createElement(S.TextualContent, null,
                React.createElement(S.Label, null, "Continue your launch guide:"),
                React.createElement(S.Title, null, title)),
            React.createElement(S.CloseButton, { title: "Close", onClick: (e) => {
                    e.stopPropagation();
                    onClose();
                } },
                React.createElement(Icon, { component: CloseIcon, height: 10 })))));
};
